import React from 'react';
import clsx from 'clsx';

import DangerCircleSvg from '../styles/assets/icons/DangerCircleSvg';
import GreenTickSvg from '../styles/assets/icons/GreenTickSvg';
import InfoBlue from '../styles/assets/icons/InfoBlue';

import styles from './InfoBlock.module.scss';

export type InfoBlockVariant = 'success' | 'warning' | 'danger' | 'info';

interface Props {
  children?: React.ReactNode;
  variant?: InfoBlockVariant;
  header?: string;
  inline?: boolean;
  showIcon?: boolean;
}

const getInfoBlockVariant = (variant?: InfoBlockVariant) => {
  let icon;
  switch (variant) {
    case 'success':
      icon = <GreenTickSvg className={styles['icon-size']} />;
      break;
    case 'warning':
      icon = <DangerCircleSvg className={styles['icon-size']} />;
      break;
    case 'danger':
      icon = <DangerCircleSvg className={styles['icon-size']} />;
      break;
    default:
      icon = <InfoBlue className={styles['icon-size']} />;
      break;
  }

  return { icon };
};

const InfoBlock = ({
  children,
  variant,
  header,
  inline = false,
  showIcon = true,
}: Props) => {
  const { icon } = getInfoBlockVariant(variant);
  return (
    <div
      className={clsx(
        styles['info-block'],
        variant && styles[variant],
        inline && styles.inline,
        'p-3',
      )}
    >
      <div className="d-flex">
        <div className={styles.icon}>
          {showIcon ? <span className="d-block">{icon}</span> : null}
        </div>
        <div className="">
          <div>
            {header ? (
              <p className={clsx(styles.header, styles.large, 'fw-bold', !children ? 'mb-0' : '')}>
                {header}
              </p>
            ) : null}
          </div>
          <div>{children ? <div>{children}</div> : null}</div>
        </div>
      </div>
    </div>
  );
};

export default InfoBlock;
